// components/RoleProtectedRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

interface Props {
  allowedRoles: string[];
}

export default function RoleProtectedRoute({ allowedRoles }: Props) {
  const { user, loading } = useAuth();

  if (!loading && !allowedRoles.includes(user?.role as string)) {
    // return <Navigate to="/dashboard" replace />;
    return <Navigate to="*" replace />;
  }

  return <Outlet />;
}
